"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonumentTabs = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _TabLink = require("./TabLink");
var _utils = require("../../utils");
var _constants = require("./constants");
var _ = require("./..");
var _utils2 = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// TODO: Rename to Tabs after Antd Tabs are fully replaced
var MonumentTabs = function MonumentTabs(_ref) {
  var children = _ref.children,
    activeKey = _ref.activeKey,
    tabsRowStyles = _ref.tabsRowStyles,
    tabLabelStyles = _ref.tabLabelStyles,
    tabLinkSliderContainerStyle = _ref.tabLinkSliderContainerStyle,
    destroyInactiveTabPane = _ref.destroyInactiveTabPane,
    theme = _ref.theme,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange,
    _ref$slideTabLinksX = _ref.slideTabLinksX,
    slideTabLinksX = _ref$slideTabLinksX === void 0 ? false : _ref$slideTabLinksX;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    tabs = _useState2[0],
    setTabs = _useState2[1];
  (0, _react.useEffect)(function () {
    setTabs(function (tabs) {
      var data = [];
      _react.default.Children.forEach(children, function (tabPane, idx) {
        if (! /*#__PURE__*/_react.default.isValidElement(tabPane)) {
          return;
        }
        var _tabPane$props = tabPane.props,
          label = _tabPane$props.label,
          disabled = _tabPane$props.disabled,
          showDot = _tabPane$props.showDot;
        var tab = (0, _lodash.find)(tabs, function (tab) {
          return tab.key === tabPane.key;
        });
        if (tab) {
          data.push(_objectSpread(_objectSpread({}, tab), {}, {
            label: label,
            disabled: disabled,
            showDot: showDot,
            component: tabPane
          }));
        } else {
          var tabKey = tabPane.key;
          var isActive = activeKey ? tabKey === activeKey : idx === 0;
          data.push({
            label: label,
            disabled: disabled,
            showDot: showDot,
            key: tabKey,
            active: isActive,
            visited: isActive,
            component: tabPane
          });
        }
      });
      return data;
    });
  }, [children]);

  // Handle key being set by parent
  (0, _react.useEffect)(function () {
    if (activeKey) {
      onActiveTabChange(activeKey);
      if (slideTabLinksX) {
        // Would be executed after the page is loaded and has all the tab links elements
        setTimeout(function () {
          return _utils.ScrollTo.target({
            selector: "#".concat(_constants.DEFAULT_TAB_LINKS_ID_PREFIX, "-").concat(activeKey)
          });
        }, 0);
      }
    }
  }, [activeKey]);
  var onActiveTabChange = function onActiveTabChange(activeTabKey) {
    setTabs(function (tabs) {
      return tabs.map(function (tab) {
        var active = tab.key === activeTabKey;
        return _objectSpread(_objectSpread({}, tab), {}, {
          active: active,
          visited: tab.visited || active
        });
      });
    });
  };
  var tabLinks = tabs.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement(_TabLink.TabLink, {
      key: tab.key,
      id: "".concat(_constants.DEFAULT_TAB_LINKS_ID_PREFIX, "-").concat(tab.key),
      tab: tab,
      theme: theme,
      tabLabelStyles: tabLabelStyles,
      showDot: tab.showDot,
      onChange: function onChange() {
        // if onChange is set we assume that active tab key value is controlled by the parent and will be passed via activeKey prop
        if (!tab.active && !_onChange) {
          onActiveTabChange(tab.key);
        }
        _onChange(tab.key);
      }
    });
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-tabs flex flex-wrap gap-x-[24px]', tabsRowStyles)
  }, slideTabLinksX && /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: "caret-left-regular-16",
    size: 16,
    onClick: function onClick() {
      return (0, _utils2.slideTabRow)();
    },
    className: "text-grey-60 mr-[16px] mb-[5px] cursor-pointer"
  }), slideTabLinksX ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(tabLinkSliderContainerStyle),
    id: _constants.DEFAULT_TAB_LINKS_CONTAINER_ID,
    style: {
      scrollBehavior: 'smooth'
    }
  }, tabLinks) : tabLinks, slideTabLinksX && /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: "caret-right-regular-16",
    size: 16,
    onClick: function onClick() {
      return (0, _utils2.slideTabRow)('right');
    },
    className: "text-grey-60 ml-[16px] mb-[5px] cursor-pointer"
  })), tabs.reduce(function (res, tab) {
    if (destroyInactiveTabPane ? tab.active : tab.visited) {
      res.push( /*#__PURE__*/_react.default.cloneElement(tab.component, {
        hidden: !tab.active
      }));
    }
    return res;
  }, []));
};
exports.MonumentTabs = MonumentTabs;